class StickyATC extends HTMLElement {
  constructor() {
    super();
    this.stickyAtcElement = this.querySelector('.sticky-atc');
    this.backToTopButton = this.querySelector('.sticky-atc__back-to-top');
    this.optionsListElement = this.querySelector('.sticky-atc__options__list');
    this.addToCartButton = this.querySelector('.sticky-atc__add-to-cart-button');
    this.productForm = document.querySelector('.product-single__form');
    this.image = this.querySelector('.sticky-atc__image-wrapper img');
    this.available = this.dataset.available === 'true';
    this.kisBackInStockEnabled = false;
    this.productOptions = JSON.parse(this.dataset.productOptions || '[]');
    this.addToCartLabel = this.dataset.addToCartLabel || 'Add to cart';
    this.bisLabel = this.dataset.bisLabel || 'Notify me';
    this._onScroll = null;
  }

  connectedCallback() {
    this.attachListeners();
  }

  attachListeners() {
    this.attachVariantChangeListener();
    this.attachBackToTopListener();
    this.attachAddToCartListener();
    this.attachDisplayListener();

    this.observeKlaviyo(() => {
      this.kisBackInStockEnabled = true;
      if (!this.available) {
        this.addToCartButton.textContent = this.bisLabel;
      }
    });
  }

  handleScroll() {
    this.classList.toggle('sticky-atc--show', window.pageYOffset > 300);
  }

  attachDisplayListener() {
    this._onScroll = () => this.handleScroll();
    window.addEventListener('scroll', this._onScroll, { passive: true });
  }

  attachVariantChangeListener() {
    document.addEventListener('variant:change', (e) => {
      const variant = e.detail.variant;
      if (!variant) return;

      const src = variant.featured_image?.src;
      if (src && this.image) {
        this.image.src = src + '&width=160';
        this.image.srcset = `${src}&width=160 160w`;
      }

      if (this.optionsListElement) {
        this.optionsListElement.textContent = '';
        this.productOptions.forEach((option, index) => {
          const optionElement = document.createElement('li');
          optionElement.textContent = `${option}: ${variant.options[index]}`;
          this.optionsListElement.appendChild(optionElement);
        });
      }

      if (!variant.available) {
        this.available = false;
        this.addToCartButton.textContent = this.kisBackInStockEnabled
          ? this.bisLabel
          : theme.strings.soldOut;
      } else {
        this.available = true;
        this.addToCartButton.textContent = `${this.addToCartLabel} - ${theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat)}`;
      }
    });
  }

  attachAddToCartListener() {
    this.addToCartButton.addEventListener('click', () => {
      if (!this.available) {
        document.querySelector('.notify-button.klaviyo-bis-trigger')?.click();
      } else {
        this.productForm?.dispatchEvent(new Event('submit'));
      }
    });
  }

  attachBackToTopListener() {
    this.backToTopButton.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  observeKlaviyo(callback) {
    const targetSelector = '.klaviyo-bis-trigger, [data-klaviyo-bis-trigger]';

    const check = () => {
      const bisButton = document.querySelector(targetSelector);
      if (bisButton) {
        if (typeof callback === 'function') {
          callback(bisButton);
        }
        if (this._observer) {
          this._observer.disconnect();
          this._observer = null;
        }
        return true;
      }
      return false;
    };

    if (check()) return;

    this._observer = new MutationObserver(() => {
      check();
    });

    this._observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  disconnectedCallback() {
    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }
    if (this._onScroll) {
      window.removeEventListener('scroll', this._onScroll);
      this._onScroll = null;
    }
  }
}

if (!customElements.get('sticky-atc')) {
  customElements.define('sticky-atc', StickyATC);
}
